import React, { forwardRef } from 'react'

import type { BaseModalProps } from '../base'
import { BaseModal } from '../base'

export const DesktopModal = forwardRef<HTMLDivElement, BaseModalProps>((props, ref) => {
    return <BaseModal ref={ref} {...props} />
})
